export default {
    BASE_URL: '',
    api: [
      {
        name: 'complexList',
        method: 'POST',
        desc: '销售统计综合列表',
        path: '/sob/SalesCountManage/complexList'
      },
      {
        name: 'projectNameList',
        method: 'GET',
        desc: '拉取项目列表',
        path: '/crm/project/selectAllProjs'
      },
      {
        name: 'userNameList',
        method: 'GET',
        desc: '拉取客户列表',
        path: '/org/selectAllCustomers'
      },
      {
        name: 'conditions',
        method: 'GET',
        desc: '拉取供货单位和业务类型列表',
        path: '/sob/SalesCountManage/conditions'
      },
      // {
      //   name: 'categoryList',
      //   method: 'GET',
      //   desc: '拉取商品分类列表',
      //   path: '/category/getBuildMetaCates'
      // },
      {
        name: 'customerList',
        method: 'POST',
        desc: '销售统计客户列表',
        path: '/sob/SalesCountManage/customerList'
      },
      {
        name: 'projectList',
        method: 'POST',
        desc: '销售统计项目列表',
        path: '/sob/SalesCountManage/projectList'
      },
      // 列表导出
      {
        name: 'expComplexList',
        method: 'POST',
        desc: '销售统计综合列表导出',
        path: '/sob/SalesCountManage/expComplexList'
      },
      {
        name: 'expCustomerList',
        method: 'POST',
        desc: '销售统计客户列表导出',
        path: '/sob/SalesCountManage/expCustomerList'
      },
      {
        name: 'expProjectList',
        method: 'POST',
        desc: '销售统计项目列表导出',
        path: '/sob/SalesCountManage/expProjectList'
      }
    ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/statistics/sales.js